// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"ModalStyle_dropdownMenu__VCrt1","option":"ModalStyle_option__Vi6hG"};